// Utility functions for converting UTC timestamps to Melbourne local time, formatted as either a date or a date and time string.
const MELBOURNE_TIMEZONE = "Australia/Melbourne";

export const convertToMelbourneDate = utc => new Intl.DateTimeFormat("en-CA", {
    timeZone: MELBOURNE_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
}).format(new Date(utc));

export const convertToMelbourneTime = utc => {
    const parts = new Intl.DateTimeFormat("en-AU", {
        timeZone: MELBOURNE_TIMEZONE,
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    }).formatToParts(new Date(utc));
    const hour = parts.find((part) => part.type === "hour")?.value ?? "";
    const minute = parts.find((part) => part.type === "minute")?.value ?? "";
    const dayPeriod = (parts.find((part) => part.type === "dayPeriod")?.value ?? "").toLowerCase();
    return `${hour}:${minute} ${dayPeriod}`;
};

export const convertToMelbourneDateAndTime = utc => new Intl.DateTimeFormat("en-AU", {
    timeZone: MELBOURNE_TIMEZONE,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
}).format(new Date(utc));